import { render } from "./TestDetail.vue?vue&type=template&id=a45fd786"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__